import { isPlatform } from "@ionic/react";
import { Capacitor } from "@capacitor/core";

export function isNativeMobile(): boolean {
  return (
    (isPlatform("ios") || isPlatform("android")) && Capacitor.isNativePlatform()
  );
}
